import { Button, Flex } from "@mantine/core"
import { useState } from "react"
import { Medication } from "./Medication"
import { Condition } from "./Condition"
import { Procedure } from "./Procedure"
import { Appointment } from "./Appointments"
import { AllergyIntolerance } from "./Allergy"


interface Props {
  pName: any;
}
export const MedicalHistory: React.FC<Props> = ({ pName }) => {
  const [activatTab, setActiveTab] = useState("Medications");
  const subTabs = [
    "Medications",
    "Conditions",
    "Procedures",
    "Allergy Intolerance",
  ];

  return (
    <>
      <Flex align={"center"} gap={10}>
        {subTabs.map((val) => {
          return (
            <Button
              onClick={(e) => {
                e.preventDefault();
                setActiveTab(val);
              }}
              variant={activatTab === val ? "filled" : "outline"}
              type="button"
              key={val}
            >
              {val}
            </Button>
          );
        })}
      </Flex>
      {activatTab === "Medications" && <Medication pName={pName} />}
      {activatTab === "Conditions" && <Condition />}
      {activatTab === "Procedures" && <Procedure />}
      {activatTab === "Allergy Intolerance" && <AllergyIntolerance />}

      {/* {activatTab === "Appointments" && <Appointment />} */}
    </>
  );
};